/**
 * @generated SignedSource<<df25f8c8c9f1e10deb639df6f0469102>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type CheckoutDeliveryReview_transaction$data = {
  readonly sku: {
    readonly " $fragmentSpreads": FragmentRefs<"PreQuoteTitle_sku">;
  } | null;
  readonly " $fragmentSpreads": FragmentRefs<"PreQuoteTitle_transaction">;
  readonly " $fragmentType": "CheckoutDeliveryReview_transaction";
};
export type CheckoutDeliveryReview_transaction$key = {
  readonly " $data"?: CheckoutDeliveryReview_transaction$data;
  readonly " $fragmentSpreads": FragmentRefs<"CheckoutDeliveryReview_transaction">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "CheckoutDeliveryReview_transaction",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "PreQuoteTitle_transaction"
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "ItemSkuType",
      "kind": "LinkedField",
      "name": "sku",
      "plural": false,
      "selections": [
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "PreQuoteTitle_sku"
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Transaction",
  "abstractKey": null
};

(node as any).hash = "e58d396c7ee362ca9f5deebf837261ec";

export default node;
